import { CacheStrategy } from '@rammetec/data-access';
import { AUDIT_FIELD_DESCRIPTORS, AUDIT_FOREIGN_KEYS } from './_auditFields.js';
import { BUSINESS_ALLOWED_DATA_SOURCES, BUSINESS_DEFAULT_DATA_SOURCE } from './dataSourcePolicy.js';
import { TAG } from '../types/tag.js';
import { FIELD_LIMITS } from '../validation/fieldLimits.js';
export const tagDescriptor = {
    name: TAG,
    label: 'Tag',
    domain: 'catalog',
    collectionPath: 'org/{orgId}/tag',
    pathPatternKeys: {
        orgId: 'string',
    },
    version: 1,
    description: 'Reusable tag for classifying entities',
    repositoryConfig: {
        dataSource: BUSINESS_DEFAULT_DATA_SOURCE,
        cache: CacheStrategy.InMemory,
    },
    allowedDataSources: BUSINESS_ALLOWED_DATA_SOURCES,
    fields: [
        {
            name: 'id',
            label: 'ID',
            type: 'string',
            required: true,
            description: 'Unique tag identifier',
        },
        {
            name: 'name',
            label: 'Nome',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.NAME,
            description: 'Tag name',
        },
        {
            name: 'color',
            label: 'Cor',
            type: 'string',
            required: true,
            description: 'Tag hex color (e.g. #FF5733)',
        },
        ...AUDIT_FIELD_DESCRIPTORS,
    ],
    foreignKeys: [...AUDIT_FOREIGN_KEYS],
};
//# sourceMappingURL=tag.descriptor.js.map